import React from 'react';
import { motion } from 'framer-motion';

const WhoItsFor: React.FC = () => {
  return (
    <section className="py-20 bg-[#F5F5F0]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            The Cloud Acceleration Program has worked for many.<br />
            But is it right for you?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          <motion.div 
            className="bg-white rounded-2xl p-8 shadow-sm relative overflow-hidden"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            style={{
              backgroundImage: 'url("/wave.svg")',
              backgroundPosition: 'bottom',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover'
            }}
          >
            <h3 className="text-2xl font-bold text-gray-900 mb-6">What You Need</h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-green-100 text-green-500">
                    ✓
                  </span>
                </div>
                <p className="ml-3 text-gray-700">
                  <strong>Dedication to learn</strong> and commitment to hands-on practice
                </p>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-green-100 text-green-500">
                    ✓
                  </span>
                </div>
                <p className="ml-3 text-gray-700">
                  <strong>Basic technical background</strong> or willingness to learn fundamentals
                </p>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-green-100 text-green-500">
                    ✓
                  </span>
                </div>
                <p className="ml-3 text-gray-700">
                  <strong>6-12 months</strong> to invest in your future
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div 
            className="bg-white rounded-2xl p-8 shadow-sm relative overflow-hidden"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            style={{
              backgroundImage: 'url("/wave.svg")',
              backgroundPosition: 'bottom',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover'
            }}
          >
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Not For You If</h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-red-100 text-red-500">
                    ✕
                  </span>
                </div>
                <p className="ml-3 text-gray-700">
                  <strong>You're looking for a quick fix</strong> without putting in the work
                </p>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-red-100 text-red-500">
                    ✕
                  </span>
                </div>
                <p className="ml-3 text-gray-700">
                  <strong>You want certifications</strong> without real-world skills
                </p>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-red-100 text-red-500">
                    ✕
                  </span>
                </div>
                <p className="ml-3 text-gray-700">
                  <strong>You're only interested in the salary</strong> without passion for technology
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div 
          className="max-w-3xl mx-auto text-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <p className="text-lg text-gray-700 mb-4">
            We'll teach you the practical skills and best practices that have worked for us and our students, but your success depends on your commitment to learning.
          </p>
          <p className="text-lg text-gray-700">
            If you're ready to put in the work and build a rewarding career in cloud engineering, then this program is for you.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default WhoItsFor; 